import React from 'react';
import { Box, Grid } from '@mui/material';
import { Button, Drawer, FloatingLabelInput } from '../../../../../../../ui';

interface ICreateNewQuestion {
  isOpen: boolean;
  onCloseDrawer: () => void;
}

export const CreateNewQuestion: React.FC<ICreateNewQuestion> = ({
  isOpen,
  onCloseDrawer,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onCloseDrawer}
      footerContent={
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, width: '100%' }}>
          <Button label="Cancel" onClick={onCloseDrawer} variant="secondary" />
          <Button label="Create" onClick={() => {}} variant="primary" />
        </Box>
      }
      title="Create New Question"
      width="w-full md:w-1/3"
    >
      <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <FloatingLabelInput
          label="Job Title"
          type="text"
          placeholder="Job title"
          required
          value=""
          onChange={() => {}}
        />
        <FloatingLabelInput
          label="Answer"
          type="text"
          placeholder="Answer"
          required
          value=""
          onChange={() => {}}
        />
        <Box>
          <Button label="Upload Media" onClick={() => {}} variant="secondary" />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FloatingLabelInput
              label="Skill"
              type="text"
              placeholder="Skill"
              required
              value=""
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FloatingLabelInput
              label="Sub-skill-1"
              type="text"
              placeholder="Sub-skill-1"
              required
              value=""
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FloatingLabelInput
              label="Level"
              type="text"
              placeholder="Level"
              required
              value=""
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FloatingLabelInput
              label="Question Type"
              type="text"
              placeholder="Question Type"
              required
              value=""
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FloatingLabelInput
              label="Timer (Seconds)"
              type="text"
              placeholder="Timer (Seconds)"
              required
              value=""
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FloatingLabelInput
              label="Point For Question"
              type="text"
              placeholder="Point For Question"
              required
              value=""
              onChange={() => {}}
            />
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

export default CreateNewQuestion;
